// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__lWIy2","title":"styles_title__2plt1","textContainer":"styles_textContainer__3NDAk"};